import { SystemField } from "./system-field";

export class KitSpecDetail extends SystemField{ 
     is_active?:number;
     description?:string;
     note?:string;
     component_qty?:number;
     min_qty?:number;
     max_qty?:number;
     unit?:number;
     allow_variance?:number;
     kit_specification_id?:string;
     component_id?:string;
}
